import {ExerciseChat} from './ExerciseChat';
export default ExerciseChat;
